import Vue from 'vue';
import vuetify from './plugins/vuetify';
import VueSweetalert2 from 'vue-sweetalert2';
import VueCookies from 'vue-cookies';
// Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);
Vue.use(VueCookies);

// set default config: session cookies
VueCookies.config('0');

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
